/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_SpeechInputs */



/**
* | output |
* | --- |
* | "Speech Synthesis (Text-To-Speech)^" |
*
* @param {Signup_Compare_SpeechInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_speech = /** @type {((inputs?: Signup_Compare_SpeechInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_SpeechInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Speech Synthesis (Text-To-Speech)^")
	if (locale === "de") return /** @type {LocalizedString} */ ("Speech Synthesis (Text-To-Speech)^")
	if (locale === "it") return /** @type {LocalizedString} */ ("Speech Synthesis (Text-To-Speech)^")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Speech Synthesis (Text-To-Speech)^")
	if (locale === "es") return /** @type {LocalizedString} */ ("Speech Synthesis (Text-To-Speech)^")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Speech Synthesis (Text-To-Speech)^")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Speech Synthesis (Text-To-Speech)^")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Speech Synthesis (Text-To-Speech)^")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Speech Synthesis (Text-To-Speech)^")
	return /** @type {LocalizedString} */ ("Speech Synthesis (Text-To-Speech)^")
});